import Input from "./Inputs/Input";
import InputCheckbox from "./Inputs/InputCheckBox";

import workshops from "../data/workshops.json";
import events from "../data/events.json";
import terms from "../data/terms.json";

import InputRadio from "./Inputs/InputRadio";
import InputRadioSingle from "./Inputs/InputRadioSingle";
import { ParticipantIconText } from "./ParticipantIconText/ParticipantIconText";
import { ParticipantIcon } from "../icons/ParticipantIcon";
import { Xx } from "./Xx/Xx";
import { useState } from "react";
import InputRow from "./Inputs/InputRow";
import { Col, Row } from "react-bootstrap";

export default function Participant({
  errors,
  register,
  id,
  participantsLength,
  handleRemove,
}) {
  const [radioChecked, setRadioChecked] = useState({
    [`registrationType${id}`]: false,
    [`proceedingsFormat${id}`]: false,
    [`tShirtYesNo${id}`]: false,
    [`tShirtType${id}`]: false,
  });
  function removeParticipant() {
    handleRemove(id);
  }

  function handleRadioClick(radioObject) {
    const stateObject = { ...radioChecked };
    stateObject[radioObject.name] = radioObject.checked;
    setRadioChecked({ ...stateObject });
  }

  return (
    <div className="div">
      <div className="frame">
        <div className="frame-2">
          <div className="icon-text-wrapper">
            <ParticipantIconText
              text={`UDELEŽENEC / UDELEŽENKA`}
              className="design-component-instance-node"
              icon={<ParticipantIcon className="uporabnik-icon-instance" />}
            />
          </div>
          {participantsLength > 1 && (
            <Xx
              className="design-component-instance-node"
              onClick={removeParticipant}
            />
          )}
        </div>
      </div>

      <Input
        label="Ime"
        labelClass="vertical-align"
        required={true}
        inputType="text"
        id={`firstName${id}`}
        name={`firstName${id}`}
        placeholder="Ime"
        error={errors[`firstName${id}`]?.message}
        register={register}
      />

      <Input
        label="Priimek"
        labelClass="vertical-align"
        required={true}
        inputType="text"
        id={`lastName${id}`}
        name={`lastName${id}`}
        placeholder="Priimek"
        error={errors[`lastName${id}`]?.message}
        register={register}
      />

      <Input
        label="E-naslov"
        labelClass="vertical-align"
        required={true}
        inputType="text"
        id={`email${id}`}
        name={`email${id}`}
        placeholder="E-naslov"
        error={errors[`email${id}`]?.message}
        register={register}
      />

      <Input
        label="Koda"
        labelClass="vertical-align"
        required={false}
        inputType="text"
        id={`payload${id}`}
        name={`payload${id}`}
        placeholder="Koda za brezplačno udeležbo"
        register={register}
      />

      {/*numberOfParticipants > 1 && (
        <div className="row">
          <div className="col-25">
            <label htmlFor="contactPerson">Kontaktna oseba</label>
          </div>
          <div className="col-75">
            <input
              type="radio"
              id={`contactPerson${id}`}
              name="contactPerson"
              value={`contactPerson${id}`}
              //onClick={selectContactPerson}
              //checked={contactPerson === `participant${id}`}
              {...register(`contactPerson`)}
            />
          </div>
        </div>
      )*/}

      <InputRadioSingle
        label={"Tip kotizacije"}
        opt1={"Redna"}
        opt2={"Sponzorska"}
        name={`registrationType${id}`}
        state={radioChecked}
        onClick={handleRadioClick}
        register={register}
      />

      <InputRadioSingle
        label={"Oblika zbornika"}
        opt1={"USB"}
        opt2={"Knjiga"}
        name={`proceedingsFormat${id}`}
        state={radioChecked}
        onClick={handleRadioClick}
        register={register}
      />

      <InputRadioSingle
        label={"Majica"}
        opt1={"Ne"}
        opt2={"Da"}
        name={`tShirtYesNo${id}`}
        state={radioChecked}
        onClick={handleRadioClick}
        register={register}
      />

      {radioChecked[`tShirtYesNo${id}`] === true && (
        <InputRadioSingle
          opt1={"Moška"}
          opt2={"Ženska"}
          name={`tShirtType${id}`}
          state={radioChecked}
          onClick={handleRadioClick}
          register={register}
        />
      )}

      {radioChecked[`tShirtYesNo${id}`] === true && (
        <InputRow
          label={"Številka majice"}
          name={`tShirtSize${id}`}
          register={register}
        />
      )}

      <InputRadio
        label="Prijava na delavnico"
        items={workshops}
        name={`workshop${id}`}
        register={register}
      />

      <InputCheckbox
        label="Udeležil(a) se bom"
        items={events}
        name={`event${id}`}
        register={register}
      />

      <Row>
        <Col md={{ offset: 1, span: 4 }}>
          <label htmlFor="specialDietary ">Posebne prehranske zahteve:</label>
        </Col>
        <Col md={6}>
          <textarea
            className="p-2"
            rows="4"
            cols="50"
            maxLength={255}
            id={`specialDietary${id}`}
            name={`specialDietary${id}`}
            placeholder="npr. vegetarijanska dieta"
            {...register(`specialDietary${id}`)}
          ></textarea>
        </Col>
      </Row>
      <Row>
        <Col md={{span: 11, offset: 1}}>
          {terms.map((t, index) => {
            return (
              <div key={index} >
                <label className="checkbox-container">
                  {t.title}
                  <input
                    type="checkbox"
                    id="termsCheckbox"
                    name={`terms${id}`}
                    value={t.value}
                    {...register(`terms${id}`)}
                  />
                  <span className="checkmark-checkbox"></span>
                </label>
              </div>
            );
          })}
        </Col>
      </Row>
    </div>
  );
}
